require('./styles/zip-input.scss');
riot.tag2('zip-input', '<div class="zip-input js-zip-input"> <form class="zip-input__form {zip-input__form--error: formError}" onsubmit="{submitZipcode}"> <label class="zip-input__label" for="zip-input">{zipcodeInputPlaceholder}</label> <input class="zip-input__textfield" oninput="{validateZipcode}" placeholder="{zipcodeInputPlaceholder}" name="zip-input" maxlength="5"> <button class="zip-input__sbmt" aria-label="submit button" disabled="{buttonDisabled}" data-tracking="{trackingChangeZipData}"> <acr-svg svg-id="arrow-noOutline" svg-class="acr-icon" svg-viewbox="0 0 26 26"></acr-svg> </button> <span class="zip-input__error acr-paragraph-9"> {zipcodeError} </span> </form> <button class="zip-input__zip-btn acr-paragraph-9" onclick="{showForm}"> <acr-svg svg-id="your-location" svg-class="acr-icon" svg-viewbox="0 0 26 26"></acr-svg> {zipcodeLabel} {localZip} </button> </div>', '', '', function(opts) {
    var self = this;
    var container;
    var inputElement;
    var zipcodeValue;
    var trackingJSON = require('./data/tracking-data');
    var utility = window.Utility;
    var acrZipInput  = window.AcrZipInput || {} ;

    const cookiePresetClass = 'cookie-preset';

    self.trackingChangeZipData = JSON.stringify(trackingJSON.changeZip);

    window.addEventListener('zipcodeUpdate', zipcodeEvent);

    self.zipcodeInputPlaceholder = acrZipInput.placeHolderText;
    self.zipcodeError = acrZipInput.errorText;
    self.zipcodeLabel = acrZipInput.locationText;
    self.cookieZip = utility.getCookie('zipcode');
    self.buttonDisabled = false;
    self.formError = false;
    self.formVisible = false;
    self.localZip;

    function refreshTrackingZipcodeSubmit(zipcode) {
      var jsonData = JSON.parse(self.trackingChangeZipData);
      jsonData.Dealer.dealer_locator_search_term = zipcode;
      self.trackingChangeZipData = JSON.stringify(jsonData);
    }

    function zipcodeEvent(event) {
      var zipcodeAvailable = event.detail && event.detail.zipcode;
      var data;

      if (zipcodeAvailable) {
        self.cookieZip = event.detail.zipcode;
        updateView(self.cookieZip);
      }
    }

    function validateZipcode(event) {
      var inputElement = event.currentTarget;
      var inputValue = inputElement.value;
      var antiRegex = new RegExp(/[^0-9]+/g);
      var validZipcode = new RegExp(/^\d{5}$/);

      self.formError = false;
      inputElement.value = inputValue.replace(antiRegex, '');
      if(inputValue.match(validZipcode)) {
        refreshTrackingZipcodeSubmit(inputElement.value);
        self.buttonDisabled = false;
      } else {
        self.buttonDisabled = true;
      }
    }

    function updateView(zipcode) {
      container.classList.add(cookiePresetClass);
      self.localZip = zipcode;
      self.update();
    }

    function showForm() {
      document.addEventListener('mousedown', documentClick, false);
      container.classList.remove(cookiePresetClass);
      inputElement.focus();
    }

    function hideForm() {
      document.removeEventListener('mousedown', documentClick, false);
      container.classList.add(cookiePresetClass);
      inputElement.value = "";
    }

    function validZipcodeSubmit() {
      var isEmbeddedInRAQ = self.parent.root.hasAttribute('is-embedded-in-raq');
      self.formError = false;
      self.localZip = zipcodeValue;

      if (!isEmbeddedInRAQ) {
        var zipcodeUpdateEvent = utility.createEvent('zipcodeUpdate', {zipcode: zipcodeValue});
        window.dispatchEvent(zipcodeUpdateEvent);
      }
      else {
        var dealerSearchEvent = utility.createEvent('dealerSearch', {zipcode: zipcodeValue});
        window.dispatchEvent(dealerSearchEvent);
      }
      hideForm();
    }

    function showError() {
      self.formError = true;
      self.update();
    }

    function submitZipcode(event) {
      var data = {};

      event.preventDefault();
      zipcodeValue = inputElement.value;

      utility.validateZipcode(zipcodeValue, validZipcodeSubmit, showError);
    }

    function documentClick(event) {
      if(self.root.contains(event.target)) {
        return;
      }

      self.formError = false;
      hideForm();
    };

    self.on('mount', function mount() {
      container = self.root.querySelector('.zip-input');
      inputElement = container.querySelector('.zip-input__textfield');

      if (self.cookieZip) {
        updateView(self.cookieZip);
      }
    });

    self.validateZipcode = validateZipcode;
    self.submitZipcode = submitZipcode;
    self.showForm = showForm;
});
